import React, { useEffect, useState } from 'react';
import { withNamespaces } from 'react-i18next';
import {
    Modal, 
    ModalHeader, 
    ModalBody, 
    ModalFooter,
    Button, 
    FormGroup, 
    Label, 
    Input,
    Spinner
} from 'reactstrap';

const EditRecurringTaskConfirmModal = ({ 
    show, 
    toggle, 
    onConfirm,
    title,
    checkBoxText,
    inProcess,
    t
}) => {
    const [applyToAll, setApplyToAll] = useState(false);

    const handleConfirm = () => {
        onConfirm(applyToAll);
    };

    useEffect(() => {
        if(show){
            setApplyToAll(false)
        }
    }, [show])

    return (
        <Modal isOpen={show} toggle={toggle}>
            <ModalHeader toggle={toggle}>
                {t(title)}
            </ModalHeader>
            <ModalBody>
                <p>
                    {t('This task is part of a recurring series')}.
                </p>
                <FormGroup check>
                    <Label check>
                        <Input
                            type="checkbox"
                            checked={applyToAll}
                            onChange={(e) => setApplyToAll(e.target.checked)}
                        />
                        {t(checkBoxText)}
                    </Label>
                </FormGroup>
            </ModalBody>
            <ModalFooter>
                <Button 
                    color="primary" 
                    onClick={handleConfirm}
                    disabled={inProcess}
                >
                    {inProcess && (
                        <Spinner 
                            size='sm'
                            color='white'
                            className='me-1'
                        />
                    )}
                    {t('Save')}
                </Button>
                <Button color="secondary" onClick={toggle}>
                    {t('Cancel')}
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default withNamespaces()(
    EditRecurringTaskConfirmModal
);